"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Map of escaped characters.
 * @private
 */

var unescapeMap = {
  '&amp;': '&',
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&#x27;': "'",
  '&#x60;': '`'
};
/**
 * Unescape some `text`.
 */

var unescapeText = function unescapeText(text) {
  if (text === void 0) {
    text = '';
  }

  var regex = new RegExp("(?:" + Object.keys(unescapeMap).join('|') + ")", 'g');
  return text.replace(regex, function (match) {
    return unescapeMap[match];
  });
};

exports.default = unescapeText;